import { Qualifier, Typography, TypographyProps } from 'bento';
import { formLabelQualifier } from './formLabelCssDefs';

export type FormLabelProps = {
  qualifier?: Qualifier;
  disabled?: boolean;
} & Omit<TypographyProps, 'ref'>;

/**
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const FormLabel = ({ qualifier, disabled, mb, children, ...rest }: FormLabelProps) => {
  const renderQualifier = () => {
    if (qualifier === 'required' || qualifier === 'optional') {
      return qualifier === 'required' ? (
        <Typography variant="caption" color="dangerBase" component="span" css={formLabelQualifier}>
          *
        </Typography>
      ) : (
        <Typography variant="caption" color="subtle" component="span" css={formLabelQualifier}>
          (optional)
        </Typography>
      );
    } else {
      return null;
    }
  };
  return (
    <Typography variant="captionStrong" color={disabled ? 'disabled' : 'default'} mb={mb} {...rest}>
      {children}
      {!disabled && renderQualifier()}
    </Typography>
  );
};
